/** @format */

import {calcForecast} from 'features/forecast/helpers/calcForecast';
import {calcComplexForecast} from 'features/forecast/helpers/calcComplexForecast';

import {ForecastInput, MetricForecast} from '../types';

export const calcMetricForecast = (input: ForecastInput): MetricForecast => {
  if (input.kind === 'additive') {
    const primary = calcForecast({
      values: input.factDaily,
      forecastDays: input.forecastDays,
    });

    if (input.withSecondary === false) {
      return {primary};
    }

    const secondary = calcForecast({
      values: input.factDaily,
      forecastDays: input.forecastDays,
      isCumulative: true,
    });
    return {primary, secondary};
  }

  const forecastA = calcForecast({values: input.a, forecastDays: input.forecastDays});
  const forecastB = calcForecast({values: input.b, forecastDays: input.forecastDays});
  const primary = calcComplexForecast({
    forecastA,
    forecastB,
    predicate: input.forecastRange,
    forecastDays: input.forecastDays,
  });
  return {primary};
};
